import { LoadingOutlined } from "@ant-design/icons";
import { Spin as AntdSpin } from "antd";
import classNames from "classnames";
import React from "react";

import styles from "./style.module.css";

const Spin = ({ className = "", indicatorClassName = "", ...rest }) => {
  return (
    <AntdSpin
      {...rest}
      className={classNames(styles.container, className)}
      indicator={<LoadingOutlined className={classNames(styles.indicatorContainer, indicatorClassName)} spin />}
    />
  );
};

export default Spin;
